import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "new-medical-option",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full pb-2" }, "オプションメニュー登録", -1)

import { onBeforeMount, ref, inject } from "vue";
import { get, set } from "@vueuse/core";
import { IMedicalOption } from "@/clinic/typings";
import MedicalOptionsFormComponent from "./components/form.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  setup(__props) {

const medicalOption = ref<IMedicalOption>({} as IMedicalOption);
const clinicId = ref(0);

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(MedicalOptionsFormComponent, {
      model: medicalOption.value,
      clinicId: clinicId.value
    }, null, 8, ["model", "clinicId"])
  ]))
}
}

})